import React, { forwardRef } from "react";
import { GiConvergenceTarget } from "react-icons/gi";

import { CenterFocusStrong, FitScreenRounded } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

const FitButton = forwardRef(({ onFitChart }, ref) => {
  const hoverBtnDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Fit Chart To Screen</p>
  );

  return (
    <div>
      <Tooltip
        title={hoverBtnDescription}
        disableinteractive="true"
        slotprops={{
          tooltip: {
            sx: {
              bgcolor: "#545859",
            },
          },
        }}
      >
        <Button
          variant="contained"
          className="context-menu-btns"
          sx={{
            backgroundColor: "#ffffff",
            border: "1px solid #00449e",
            borderColor: "#00449e",
            cursor: "pointer",
            borderRadius: "0.5rem",
            color: "#00449e",
                "&:hover": {
                  backgroundColor: "#eaf1fb",
                },
                "&:focus:not(:hover)": {
                  backgroundColor: "#ffffff",
                  boxShadow: "none",
                },
          }}
          onClick={(event) => onFitChart(event)}
          ref={ref}
        >
          <GiConvergenceTarget size="1rem" color="#00449e"/>
        </Button>
      </Tooltip>
    </div>
  );
});

export default FitButton;
